const PATH_PROBE_BASE = 'https://__session_redirect__.invalid'

/**
 * Validates Supabase/email `next` redirect targets: same-site relative paths only.
 * Prevents open redirects via `//evil`, encoded slashes, and absolute URLs.
 */
export function resolveSafeNextPath(next: string | null | undefined, fallback = '/'): string {
  const safeFallback =
    fallback.startsWith('/') && !fallback.startsWith('//') && !fallback.includes('\\')
      ? fallback
      : '/'

  if (next == null || next === '') return safeFallback

  const t = next.trim()
  if (t.length === 0 || t.length > 2048) return safeFallback

  if (!t.startsWith('/') || t.startsWith('//') || t.includes('\\')) return safeFallback

  if (/%5[cC]|%2[fF]%2[fF]|\\|%00/u.test(t)) return safeFallback

  try {
    const resolved = new URL(t, PATH_PROBE_BASE)
    if (resolved.origin !== PATH_PROBE_BASE || resolved.protocol !== 'https:') {
      return safeFallback
    }
    const path = `${resolved.pathname}${resolved.search}${resolved.hash}`
    if (!path.startsWith('/') || path.startsWith('//')) return safeFallback
    return path.length > 0 ? path : safeFallback
  } catch {
    return safeFallback
  }
}
